<template>
	<!-- Balance and main content -->
	<div class="w-full md:w-3/4 lg:w-4/5 h-full flex flex-col items-start pair-bg overflow-y-auto custom-scrollbar md:rounded-tr-2xl md:rounded-bl-none md:rounded-tl-none rounded-b-2xl z-10">
		<div class="flex items-center justify-between w-full px-4 md:pt-12 md:px-8">
			<div class="flex items-center justify-center ml-4 md:ml-0">
				<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkMainSend : lightMainSend" alt="Send Icon" class="w-6 h-6 md:w-8 md:h-8 mr-3"/>
				<h1 class="text-2xl md:text-4xl font-archivomedium text-[var(--text-color)]">
					Send
				</h1>
				<img :src="selectedChain.icon" alt="Chain Icon" class="w-8 h-8 md:w-10 md:h-10 mb-4 ml-2 mt-4 cursor-pointer md:top-16 md:right-16"/>
				<button @click="$emit('backToOverview')" class="hidden md:block absolute top-8 right-8 z-20">
					<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkX : lightX" alt="Close Icon" class="w-3 h-3"/>
				</button>
			</div>
			<!-- back button -->
			<button @click="$emit('backToOverview')" class="block md:hidden ml-auto md:mt-2 mr-4 flex items-center space-x-1 px-3 py-2 text-sm font-archivoregular text-[var(--secondary-text-color)] bg-[var(--accent-color-50)] hover:bg-[var(--accent-color-30)] rounded-full transition-colors">
				<svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
					<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
				</svg>
				<span class="hover:text-[var(--secondary-text-color)] text-xs">Back</span>
			</button>
		</div>
		
		<div class="my-2 mx-auto w-full md:w-[80%] lg:w-[65%] xl:w-[50%] p-4">
			<div v-if="selectedChain.name !== 'Bitcoin'" class="mb-2 font-archivolight text-[var(--text-color)]">
				<span class="text-md font-archivomedium text-[var(--text-color)]">
					From:
				</span>
				<span class="text-sm font-archivolight text-[var(--secondary-text-color)]">
					{{ selectedAccount.name }}:
				</span>
				<span class="text-sm font-archivolight text-[var(--secondary-text-color)]">
					[{{ selectedAccount.address.slice(0,4) + '....' + selectedAccount.address.slice(-5) }}]
				</span> 
			</div>
			<div class="balance-bg p-4 rounded-lg shadow-xl mb-4 flex flex-col items-center justify-center border border-[var(--border-color)]">
				<h1 class="text-md font-archivolight text-[var(--text-color)]">
					Available:
				</h1>
				<h2 class="text-2xl font-archivomedium text-center text-[var(--text-color)]">
					{{ selectedAssetObject.balance }} {{ selectedAssetObject.symbol }}
				</h2>
				<p class="text-sm font-archivolight text-[var(--secondary-text-color)]">
					(~${{ availableUsd }})
				</p>
			</div>

		<!-- Asset Dropdown for EVM Chains -->
		<div v-if="selectedChain.name !== 'Bitcoin'" class="w-full mb-2">
			<label class="block font-archivomedium text-[var(--secondary-text-color)] mb-2">
				Select Asset:
			</label>
			<div class="relative">
				<button @click="$emit('toggleAssetDropdown')" class="w-full flex items-center justify-between bg-[var(--select-asset-color)] shadow-lg rounded-lg px-4 py-3 hover:shadow-xl transition-all duration-100">
					<div class="flex items-center">
						<img :src="selectedAssetObject.icon" alt="Asset Icon" class="w-6 h-6 mr-4"/>
						<span class="text-sm font-archivomedium text-[var(--secondary-text-color)]">
							{{ selectedAssetObject.name }} ({{ selectedAssetObject.symbol }})
						</span>
					</div>
						<svg :class="{'rotate-180 transform transition-transform duration-100': assetDropdownOpen}" xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-[var(--secondary-text-color)]" fill="currentColor" viewBox="0 0 20 20">
						<path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"></path>
						</svg>
				</button>
				<transition name="dropdown-transition">
					<div v-if="assetDropdownOpen" class="relative">
						<div class="fixed inset-0 z-10" @click="$emit('toggleAssetDropdown')"/>
						<div class="absolute z-20 mt-2 w-full bg-[var(--select-asset-color)] rounded-lg shadow-lg">
							<button v-for="asset in assetList" :key="asset.symbol" @click="$emit('selectAsset', asset)" class="w-full text-left px-4 py-3 rounded-lg hover:bg-[var(--accent-color)] hover:text-[var(--hover-text-color)] transition-all duration-100 text-[var(--secondary-text-color)]">
								{{ asset.name }} ({{ asset.symbol }})
							</button>
						</div>
					</div>
				</transition>
			</div>
		</div>

		<!-- address block -->
		<div class="mb-4">
			<div class="flex items-center justify-between">
			<label class="block font-archivomedium text-[var(--secondary-text-color)]" for="address">
				Address:
			</label>
			<div class="relative ml-2 mb-2">
				<button @click="$emit('toggleAddressMenu')" class="p-2 hover:bg-[var(--dropdown-hover-color)] rounded-full transition">
					<svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-[var(--secondary-text-color)]" fill="currentColor" viewBox="0 0 24 24">
					<path d="M12 7a2 2 0 110-4 2 2 0 010 4zm0 6a2 2 0 110-4 2 2 0 010 4zm0 6a2 2 0 110-4 2 2 0 010 4z"/>
					</svg>
				</button>
				<transition name="dropdown-transition">
					<div v-if="addressMenuOpen" class="relative">
						<div class="fixed inset-0 z-10" @click="$emit('update:addressMenuOpen', false)"/>
						<ul class="absolute right-0 mt-2 w-40 bg-[var(--select-asset-color)] rounded-lg shadow-lg z-20 overflow-hidden">
							<li @click="$emit('toggleSendAccountDropdown'); $emit('update:addressMenuOpen', false)" class="px-4 py-2 text-[var(--secondary-text-color)] hover:bg-[var(--accent-color)] hover:text-[var(--hover-text-color)] hover:rounded-lg cursor-pointer transition">
								Transfer
							</li>
							<li @click="$emit('toggleAddressBookPopup'); $emit('update:addressMenuOpen', false)" class="px-4 py-2 text-[var(--secondary-text-color)] hover:bg-[var(--accent-color)] hover:text-[var(--hover-text-color)] hover:rounded-lg cursor-pointer transition">
								Address Book
							</li>
						</ul>
					</div>
				</transition>
			</div>
		</div>

		<div class="relative">
			<input :value="recipientAddress" @input="$emit('update:recipientAddress', $event.target.value)" id="address" type="text" class="w-5/6 text-sm md:text-md px-2 py-3 shadow-inner rounded-l appearance-none bg-[var(--send-placeholder-color)] text-[#141523] hover:ring-1 hover:ring-[var(--accent-color-50)] focus:outline-none focus:ring-1 focus:ring-[var(--accent-color)] transition" placeholder="Recipient Address"/>
			<button  @click="$emit('startScanAddress')" class="w-1/6 absolute top-0 right-0 h-full text-sm font-archivoregular bg-[var(--send-max-color)] border-[var(--send-max-color)] text-[var(--hover-text-color)] px-1 rounded-r hover:opacity-80">
				<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkScan : lightScan" alt="Scan Icon" class="w-6 h-6 mx-auto"/>
			</button>
			<transition name="dropdown-transition">
				<div v-if="sendAccountDropdownOpen" class="relative">
					<!-- backdrop -->
					<div class="fixed inset-0 z-10" @click="$emit('update:sendAccountDropdownOpen', false)"/>
						<!-- menu -->
						<div class="absolute mt-2 w-full bg-[var(--send-dropdown-bg-color)] rounded-lg shadow-lg z-10">
						<button v-for="account in walletAccounts[selectedChain.name]" :key="account.name"  @click="() => { emit('selectSendAccount', account); emit('update:sendAccountDropdownOpen', false); }" :class="['w-full text-left px-4 py-3 rounded-lg  hover:bg-[var(--accent-color)] transition-all duration-100 hover:text-[var(--hover-text-color)] text-[var(--send-dropdown-text-color)]',account.name === selectedAccount.name ? 'opacity-40 hover:bg-[var(--send-dropdown-bg-color)] hover:text-[var(--send-dropdown-text-color)]' : 'opacity-100']">
								{{ account.name }} 
							<span class="text-sm ml-2">[{{ account.address ? account.address.slice(0, 4) + '....' + account.address.slice(-5) : '' }}]</span>
						</button>
					</div>
				</div>
			</transition>
		</div>
	</div>

		<!-- amount block -->
		<div class="mb-4">
			<label class="block font-archivomedium text-[var(--secondary-text-color)] mb-2" for="amount">
				Amount:
			</label>
			<div class="relative">
			<input :value="amountInput" @input="$emit('update:amountInput', $event.target.value)" @keyup.enter="$emit('handleFirstFee')" @blur="$emit('handleFirstFee')" id="amount" type="number" class="w-5/6 text-sm md:text-md px-2 py-3 shadow-inner rounded-l appearance-none bg-[var(--send-placeholder-color)] text-[#141523] hover:ring-1 hover:ring-[var(--accent-color-50)] focus:outline-none focus:ring-1 focus:ring-[var(--accent-color)] transition" placeholder="Amount"/>
			<span v-if="amountInput" class="absolute top-1/2 right-[20%] transform -translate-y-1/2 text-sm font-archivolight text-[var(--tertiary-text-color)]">
				(~${{ amountUsd }})
			</span>
			<button @click="$emit('setMaxAmount')" class="w-1/6 absolute top-0 right-0 h-full text-sm font-archivoregular bg-[var(--send-max-color)] text-[var(--text-color)] px-1 rounded-r hover:opacity-80">
				MAX
			</button>
			</div>
		</div>

		<label class="block font-arch text-[var(--secondary-text-color)] font-archivomedium my-6" for="amount">
		{{ selectedChain.name === 'Bitcoin' ? 'Transaction Fee' : 'Gas Fee' }}:
			<span class="font-archivoregular ml-2">
				{{ currentFee }}
			</span>
			<span v-if="feeUsdPrice" class="text-sm font-archivolight text-[var(--secondary-text-color)]">
				(~{{ feeUsdPrice }})
			</span>
		</label>

		<div class="w-full mx-auto items-center justify-center">
			<div class="flex space-x-4 w-full font-archivoregular">
				<div v-if="selectedFee==0" class="w-1/3">
					<button @click="$emit('adjustFeeRate', 0)" class="w-full bg-[var(--accent-color)] text-white border border-[var(--accent-color)] py-2 px-4 rounded-full hover:bg-[var(--accent-color)] transition duration-100 shadow-inner">
						Low
					</button>
				</div>
				<div v-else class="w-1/3">
					<button @click="$emit('adjustFeeRate', 0)" class="w-full bg-transparent text-[var(--accent-color)] border border-[var(--accent-color)] py-2 px-4 rounded-full hover:bg-[var(--accent-color)] hover:text-[var(--hover-text-color)] transition duration-100 shadow-inner">
						Low
					</button>
				</div>
				<div v-if="selectedFee==1" class="w-1/3">
					<button @click="$emit('adjustFeeRate', 1)" class="w-full bg-[var(--accent-color)] text-white border border-[var(--accent-color)] py-2 px-4 rounded-full hover:bg-[var(--accent-color)] transition duration-100 shadow-inner">
						Medium
					</button>
				</div>
				<div v-else class="w-1/3">
					<button @click="$emit('adjustFeeRate', 1)" class="w-full bg-transparent text-[var(--accent-color)] border border-[var(--accent-color)] py-2 px-4 rounded-full hover:bg-[var(--accent-color)] hover:text-[var(--hover-text-color)] transition duration-100 shadow-inner">
						Medium
					</button>
				</div>
				<div v-if="selectedFee==2" class="w-1/3">
					<button  @click="$emit('adjustFeeRate', 2)" class="w-full bg-[var(--accent-color)] text-white border border-[var(--accent-color)] py-2 px-4 rounded-full hover:bg-[var(--accent-color)] transition duration-100 shadow-inner">
						High
					</button>
				</div>
				<div v-else class="w-1/3">
					<button  @click="$emit('adjustFeeRate', 2)" class="w-full bg-transparent text-[var(--accent-color)] border border-[var(--accent-color)] py-2 px-4 rounded-full hover:bg-[var(--accent-color)] hover:text-[var(--hover-text-color)] transition duration-100 shadow-inner">
						High
					</button>
				</div>
			</div>
				<button @click="$emit('generatePSBT')" class="font-archivoregular mt-4 w-full bg-transparent text-[var(--accent-color)] border border-[var(--accent-color)] py-2 rounded-full hover:bg-[var(--accent-color)] hover:text-[var(--hover-text-color)] transition duration-100 shadow-inner">
					Send
				</button>
				<button  @click="$emit('backToOverview')" class="font-archivoregular mt-4 w-full bg-transparent text-[var(--accent-color)] border border-[var(--accent-color)] py-2 rounded-full hover:bg-[var(--accent-color)] hover:text-[var(--hover-text-color)] transition duration-100 shadow-inner">
					Back
				</button>
			</div>
		</div>
	</div>
</template>

<script setup>
	import lightMainSend from '../assets/SendIconLightTheme.png';
	import darkMainSend  from '../assets/SendIconDarkTheme.png';
	import lightScan from '../assets/QR_Light_Theme.png';
	import darkScan from '../assets/QR_Dark_Theme.png';
	import lightX from '../assets/X.png';
	import darkX from '../assets/XWhite.png';

	const props = defineProps({
		currentTheme: { type: String, required: true },
		btcOnly:  { type: Boolean, required: true },
		selectedChain: { type: Object, required: true },
		selectedAssetObject: { type: Object, required: true },
		availableUsd: { type: [String, Number], required: true },
		amountUsd: { type: [String, Number], required: true },
		assetList: { type: Array, required: true },
		walletAccounts: { type: Object, required: true },
		selectedAccount:  { type: Object, required: true },
		recipientAddress: { type: String, required: true },
		amountInput: { type: [String, Number], required: true },
		currentFee: { type: String, required: true },
		feeUsdPrice: { type: String, required: true },
		selectedFee: { type: Number, required: true },
		assetDropdownOpen: { type: Boolean, required: true },
		addressMenuOpen: { type: Boolean, required: true },
		sendAccountDropdownOpen: { type: Boolean, required: true },
		txTypeStr: { type: String, required: true },
	});

	const emit = defineEmits([
		'update:sendAccountDropdownOpen',
		'update:recipientAddress',
		'update:amountInput',
		'update:addressMenuOpen',
		'toggleAssetDropdown',
		'selectAsset',
		'toggleAddressMenu',
		'toggleAddressBookPopup',
		'toggleSendAccountDropdown',
		'startScanAddress',
		'setMaxAmount',
		'handleFirstFee',
		'adjustFeeRate',
		'generatePSBT',
		'backToOverview'
	]);
</script>

<style scoped>
	/* layout backgrounds */
	.pair-bg {
		background: var(--main-bg-color);
	}
	.balance-bg {
		background: var(--balance-bg-color);
	}

	/* custom scrollbar */
	.custom-scrollbar {
		overflow-y: auto;
		scrollbar-width: thin;
		scrollbar-color: #888 #f1f1f1;
	}
	.custom-scrollbar::-webkit-scrollbar {
		width: 8px;
	}
	.custom-scrollbar::-webkit-scrollbar-track {
		background: #f1f1f1;
		border-radius: 16px;
		margin: 5% 0;
	}
	.custom-scrollbar::-webkit-scrollbar-thumb {
		background-color: #888;
		border-radius: 8px;
	}
	.custom-scrollbar::-webkit-scrollbar-thumb:hover {
		background-color: #555;
	}

	/* fade-in / fade-out transitions */
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.2s ease-in-out;
	}
	.fade-enter-from,
	.fade-leave-to {
		opacity: 0;
	}

	input, textarea, select, button {
		font-size: 16px;
	}

	input[type="number"]::-webkit-outer-spin-button,
	input[type="number"]::-webkit-inner-spin-button {
	-webkit-appearance: none;
	-moz-appearance: none;
		appearance: none;
	}

	input[type="number"] {
		-moz-appearance: none;
	}

	.dropdown-transition-enter-from,
	.dropdown-transition-leave-to {
		opacity: 0;
		transform: scale(0.95);
	}
	.dropdown-transition-enter-to,
	.dropdown-transition-leave-from {
		opacity: 1;
		transform: scale(1);
	}

</style>
